import {
  Box,
  Button,
  Dialog,
  FormControlLabel,
  Grid,
  Radio,
  RadioGroup,
  TextField,
  Typography
} from '@mui/material';
import { useEffect, useState } from 'react';
import {
  colorContainedHoverButton,
  colorLinkGrey,
  colorPrimary,
  colorTextBlack,
  colorTextGrey
} from '../../../config/theme';
import { useDispatch } from 'react-redux';
import { reportContent } from '../../../redux/reducers/resourcesSlice';
import { useSelector } from 'react-redux';
import SnackBarBox from '../../../components/SnackBarBox';
import { handleError } from '../../../utils/utils';

function ReportModal({ isOpen, onClose, submitData }) {
  const dispatch = useDispatch();
  const [selectedOption, setSelectedOption] = useState('');
  const [description, setDescription] = useState('');

  const { authData } = useSelector(state => state.auth);

  const {
    reportContentResponse,
    isReportContentLoading,
    isReportContentSuccess,
    reportContentDataErrorContainer,
    isReportContentFailed
  } = useSelector(state => state.resource);

  useEffect(() => {
    if (!isReportContentLoading && isReportContentSuccess) {
      onClose();
      setDescription('');
      setSelectedOption('');
    }
  }, [isReportContentSuccess]);

  const handleChange = e => {
    const { value } = e.target;
    if (value?.length < 201) {
      setDescription(value);
    }
  };

  const handleRadioChange = e => {
    const { value } = e.target;
    if (value === 'others') {
      setDescription('');
    } else {
      setDescription('Description');
    }
    e.stopPropagation();
    setSelectedOption(value);
  };

  return (
    <>
      <Dialog
        sx={{
          '& .MuiDialog-paper': {
            borderRadius: '8px'
          }
        }}
        open={isOpen}
        onClose={e => onClose(e)}
      >
        <Box sx={{ padding: '40px', width: '404px' }}>
          <Typography
            fontSize={'20px'}
            fontWeight={700}
            marginBottom="16px"
            textAlign="left"
          >
            Report
          </Typography>

          <Box>
            <RadioGroup
              value={selectedOption}
              onChange={handleRadioChange}
              sx={{
                width: '100%',
                display: 'flex',
                flexDirection: 'column',
                alignItems: 'flex-start'
              }}
            >
              <FormControlLabel
                value="notGradeSpecific"
                control={
                  <Radio
                    sx={{
                      color: colorTextGrey,
                      '&.Mui-checked': {
                        color: colorPrimary
                      }
                    }}
                  />
                }
                label={
                  <Typography
                    sx={{
                      fontWeight: 700,
                      fontSize: '16px',
                      color: colorTextBlack,
                      textAlign: 'left'
                    }}
                  >
                    Not grade-specific
                  </Typography>
                }
                labelPlacement="start"
                sx={{
                  width: '100%',
                  display: 'flex',
                  justifyContent: 'space-between',
                  marginLeft: 0,
                  paddingLeft: 0
                }}
              />

              <FormControlLabel
                value="outdatedInaccurate"
                control={
                  <Radio
                    sx={{
                      color: colorTextGrey,
                      '&.Mui-checked': {
                        color: colorPrimary
                      }
                    }}
                  />
                }
                label={
                  <Typography
                    sx={{
                      fontWeight: 700,
                      fontSize: '16px',
                      color: colorTextBlack,
                      textAlign: 'left'
                    }}
                  >
                    Outdated or inaccurate information
                  </Typography>
                }
                labelPlacement="start"
                sx={{
                  width: '100%',
                  display: 'flex',
                  justifyContent: 'space-between',
                  marginLeft: 0,
                  paddingLeft: 0
                }}
              />
              <FormControlLabel
                value="poorQuality"
                control={
                  <Radio
                    sx={{
                      color: colorTextGrey,
                      '&.Mui-checked': {
                        color: colorPrimary
                      }
                    }}
                  />
                }
                label={
                  <Typography
                    sx={{
                      fontWeight: 700,
                      fontSize: '16px',
                      color: colorTextBlack,
                      textAlign: 'left'
                    }}
                  >
                    Poor quality
                  </Typography>
                }
                labelPlacement="start"
                sx={{
                  width: '100%',
                  display: 'flex',
                  justifyContent: 'space-between',
                  marginLeft: 0,
                  paddingLeft: 0
                }}
              />
              <FormControlLabel
                value="spamMisleading"
                control={
                  <Radio
                    sx={{
                      color: colorTextGrey,
                      '&.Mui-checked': {
                        color: colorPrimary
                      }
                    }}
                  />
                }
                label={
                  <Typography
                    sx={{
                      fontWeight: 700,
                      fontSize: '16px',
                      color: colorTextBlack,
                      textAlign: 'left'
                    }}
                  >
                    Spam or misleading
                  </Typography>
                }
                labelPlacement="start"
                sx={{
                  width: '100%',
                  display: 'flex',
                  justifyContent: 'space-between',
                  marginLeft: 0,
                  paddingLeft: 0
                }}
              />

              <FormControlLabel
                value="others"
                control={
                  <Radio
                    sx={{
                      color: colorTextGrey,
                      '&.Mui-checked': {
                        color: colorPrimary
                      }
                    }}
                  />
                }
                label={
                  <Typography
                    sx={{
                      fontWeight: 700,
                      fontSize: '16px',
                      color: colorTextBlack,
                      textAlign: 'left'
                    }}
                  >
                    Others
                  </Typography>
                }
                labelPlacement="start"
                sx={{
                  width: '100%',
                  display: 'flex',
                  justifyContent: 'space-between',
                  marginLeft: 0,
                  paddingLeft: 0
                }}
              />
            </RadioGroup>
          </Box>
          {selectedOption === 'others' && (
            <Box>
              <TextField
                id="standard-basic"
                label="Description"
                variant="standard"
                style={{ width: '100%' }}
                value={description}
                onChange={e => handleChange(e)}
              />
              <Typography
                style={{
                  display: 'flex',
                  justifyContent: 'flex-end',
                  fontFamily: 'Lato',
                  fontWeight: 500,
                  fontSize: '14px',
                  lineHeight: '18px',
                  color: colorLinkGrey,
                  marginTop: '5px'
                }}
              >
                {description.length || 0}/200
              </Typography>
            </Box>
          )}

          <Grid mt={2} item display={'flex'} justifyContent={'start'} gap={2}>
            <Button
              variant="outlined"
              onClick={onClose}
              sx={{
                px: 4,
                borderColor: colorPrimary,
                borderRadius: '8px',
                color: colorTextBlack,
                borderWidth: '2px',
                height: '42px',
                width: '106px',
                fontWeight: '700',
                fontSize: '14px',
                textAlign: 'left',
                textTransform: 'none',
                '&:hover': {
                  borderColor: colorPrimary,
                  backgroundColor: 'transparent',
                  borderRadius: '8px',
                  borderWidth: '2px'
                }
              }}
            >
              Cancel
            </Button>
            <Button
              variant="contained"
              disabled={!(selectedOption && description)}
              type="submit"
              sx={{
                px: 4,
                borderWidth: 2,
                width: '95px',
                textAlign: 'left',
                fontWeight: '700',
                fontSize: '14px',
                borderRadius: '8px',
                color: colorTextBlack,
                textTransform: 'none',
                backgroundColor: colorPrimary,
                '&:hover': {
                  backgroundColor: colorContainedHoverButton,
                  borderRadius: '8px',
                  borderWidth: '2px'
                }
              }}
              onClick={() => {
                console.log('submit data', submitData);
                const summary =
                  selectedOption === 'notGradeSpecific'
                    ? 'Not grade-specific'
                    : selectedOption === 'outdatedInaccurate'
                      ? 'Outdated or inaccurate information'
                      : selectedOption === 'poorQuality'
                        ? 'Poor quality'
                        : selectedOption === 'spamMisleading'
                          ? 'Spam or misleading'
                          : '';

                const payload = {
                  senderName: authData.name,
                  senderUserName: authData.userName,
                  receiverUserName:
                    submitData?.created_by || submitData?.createdBy,
                  contentTitle: submitData?.title,
                  platform: 'Web',
                  summary: selectedOption === 'others' ? description : summary
                };
                dispatch(reportContent({ payload }));
              }}
            >
              Submit
            </Button>
          </Grid>
        </Box>
      </Dialog>

      {!isReportContentLoading && isReportContentSuccess && (
        <SnackBarBox
          type="success"
          message={handleError(reportContentResponse)}
        />
      )}

      {!isReportContentLoading && isReportContentFailed && (
        <SnackBarBox
          type="error"
          message={handleError(reportContentDataErrorContainer?.errorMessage)}
        />
      )}
    </>
  );
}

export default ReportModal;
